import React, { useState, useEffect } from 'react';
import { getStaticProps as getStaticPropsMethod } from '@/bit/pages/pages.create-pages';
import { getClientType } from '@/utils/common';
import { wrapper } from 'store';
import LMClientForm from '@/forms/client/au/lm';
import LMNoClientForm from '@/forms/noClient/au/lm';
import { CLIENT_TYPE } from '@/constants/constant';
import { PATH_NAME, URL_SEO } from '@/constants/pages/mobileLines';
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';
import MetaData from '@/bit/core/core.meta-data';

const MobileLines = ({ seoInfo }) => {
  const [clientType, setClientType] = useState('');

  useEffect(() => {
    const clientStatus = getClientType();
    if (clientStatus === CLIENT_TYPE.CLIENT) {
      setClientType(CLIENT_TYPE.CLIENT);
    } else if (clientStatus === CLIENT_TYPE.SOFT_CLIENT) {
      sendToRelogin();
    } else {
      setClientType(CLIENT_TYPE.NO_CLIENT);
    }
  }, []);
  return (
    <>
      <MetaData seoInfo={seoInfo} />
      {clientType && clientType === CLIENT_TYPE.CLIENT && <LMClientForm />}
      {clientType && clientType === CLIENT_TYPE.NO_CLIENT && <LMNoClientForm />}
    </>
  );
};
export default MobileLines;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, '', 2, {
    pathname: PATH_NAME.AU,
    orionAlias: '',
    seoLocation: URL_SEO.AU,
    headerLocation: '/',
    layoutInfo: '',
  });
});
